<template>
  <div>
    <vs-prompt
      title="Duplicate this campaign"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vx-tooltip
                text="This will be the name of the duplicated campaign. It can be changed later."
                position="bottom"
              >
                <vs-input
                  class="inputx w-full"
                  placeholder="Name of the duplicated campaign"
                  v-model="name"
                />
              </vx-tooltip>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      prompt: false,
      masterCampaignId: null,
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    },
  },
  methods: {
    show(masterCampaignId) {
      this.name = "";
      this.masterCampaignId = masterCampaignId;
      this.prompt = true;
    },
    async accept() {
      const dto = {
        name: this.name,
        masterCampaignId: this.masterCampaignId
      };
      this.$vs.loading();
      try {
        const id = await this.$store.dispatch("masterCampaigns/duplicate", dto);
        this.$vs.notify({
          color: "success",
          title: `Campaign created`,
          text: "Campaign created",
        });
        this.$router
          .push({ name: "crm-campaign", params: { id: id } })
          .catch(() => {});
      } catch (e) {
        console.log("Error", e);
        this.prompt = true;
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "That campaign already exists. Please choose another name.",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
